export function clipboard( text, confirmation = 'Copied!', timeout = 4000 ) {
	try {
		navigator.clipboard.writeText( text );

		if ( this instanceof HTMLElement ) {
			const confirm = document.createElement('div');
			confirm.classList.add('share__confirm');
			confirm.appendChild( document.createTextNode( confirmation ) );

			this.classList.add('share__link--copied');
			this.appendChild( confirm );

			setTimeout( () => {
				this.classList.remove('share__link--copied');
				confirm.parentNode.removeChild( confirm );
			}, timeout );
		}
	} catch ( fault ) {
		console.error( fault );
	}
}

document.addEventListener( 'click', function(e) {
	let node = e.target;

	while ( node && node.parentNode ) {
		if ( node.matches( '.share__item--clipboard' ) ) {
			e.preventDefault();
			return clipboard.call( node, node.href );
		}

		node = node.parentNode;
	}
} );
